(function(){
  var REGION_COORDS=[
    {id:'south-asia',name:'South Asia',lat:22,lng:79},
    {id:'middle-east',name:'Middle East',lat:31,lng:44},
    {id:'persia',name:'Persia',lat:33,lng:53},
    {id:'africa',name:'Africa',lat:9,lng:21},
    {id:'east-asia',name:'East & SE Asia',lat:15,lng:106},
    {id:'mediterranean',name:'Mediterranean',lat:42,lng:13},
    {id:'americas',name:'The Americas',lat:16,lng:-92}
  ];
  var ACTIVE={}; document.querySelectorAll('.region-chip').forEach(function(c){ ACTIVE[c.getAttribute('data-region')]=1; });
  var REGIONS=REGION_COORDS.filter(function(r){ return ACTIVE[r.id]; });
  if(!REGIONS.length) REGIONS=REGION_COORDS;
  var BY_ID={}; REGIONS.forEach(function(r){ BY_ID[r.id]=r; });

  // Feature 1 — the historic spice / Silk-Road network. Only edges whose BOTH endpoints
  // are active regions become arcs, so a removed region drops its routes too.
  var ROUTE_EDGES=[
    ['east-asia','south-asia'],['south-asia','persia'],['south-asia','middle-east'],
    ['persia','middle-east'],['persia','east-asia'],['middle-east','mediterranean'],
    ['middle-east','africa'],['africa','mediterranean'],['mediterranean','americas'],
    ['east-asia','africa']
  ];
  var ARCS=[];
  ROUTE_EDGES.forEach(function(e){
    var a=BY_ID[e[0]], b=BY_ID[e[1]];
    if(a&&b) ARCS.push({from:a.id,to:b.id,startLat:a.lat,startLng:a.lng,endLat:b.lat,endLng:b.lng});
  });

  var IS_MOBILE = (window.innerWidth||1024) < 768;
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
  var NO_HOVER = !!(window.matchMedia && window.matchMedia('(hover:none)').matches);
  // Capability gate: low-end / mobile get a lean render path (fewer per-frame layers, lower res,
  // no fly-in). Capable desktops get the sharp path (2K texture, DPR up to 2, antialias, rings).
  var CORES = navigator.hardwareConcurrency || 4;
  var DEVMEM = navigator.deviceMemory || 4;
  var LOW = IS_MOBILE || CORES <= 4 || DEVMEM <= 4;
  var DPR = window.devicePixelRatio || 1;
  // Mobile screens are high-DPR — rendering at 1.25x looked badly upscaled/blurry. The scene is already
  // lean on mobile (no rings/graticules, render pauses offscreen) so full 2x is smooth and sharp.
  var PXR = IS_MOBILE ? Math.min(DPR, 2) : (LOW ? Math.min(DPR, 1.5) : Math.min(DPR, 2));
  var POV_ALT = IS_MOBILE ? 2.0 : 2.4; // pull the camera a touch closer on phones so the globe fills the frame
  if(LOW){ var _dg=document.querySelector('.disc__globe'); if(_dg) _dg.classList.add('lowfx'); }
  if(IS_MOBILE){ var _gh=document.getElementById('globeHint'); if(_gh) _gh.textContent='Swipe to spin · pinch to zoom · tap a marker'; }
  // Perf/sharpness CSS injected here (rather than in the section) for reliable delivery:
  // crisp light text on dark bg, decorative card motifs idle at zero cost until hover, static low-end starfield.
  (function(){ var s=document.createElement('style'); s.textContent=
    '.disc{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}'+
    '.cat-card__anim *{animation-play-state:paused!important}'+
    '.cat-card:hover .cat-card__anim *{animation-play-state:running!important}'+
    '.disc__globe.lowfx .starfield::before,.disc__globe.lowfx .starfield::after{animation:none!important}'+
    '.disc__globe.lowfx .globe-bloom{display:none}'+
    /* themed scrollbar for the region product list (was the default light "template" bar) */
    '.region-panel__grid{scrollbar-color:var(--gold-soft) rgba(255,255,255,.05)}'+
    '.region-panel__grid::-webkit-scrollbar{width:9px;height:9px}'+
    '.region-panel__grid::-webkit-scrollbar-track{background:rgba(255,255,255,.04);border-radius:100px;margin:4px 0}'+
    '.region-panel__grid::-webkit-scrollbar-thumb{background:linear-gradient(180deg,var(--gold),var(--gold-soft));border-radius:100px;border:2px solid transparent;background-clip:padding-box}'+
    '.region-panel__grid::-webkit-scrollbar-thumb:hover{background:var(--gold);background-clip:border-box}'+
    /* touch-friendly themed close button for the region panel */
    '.region-close{position:absolute;top:14px;right:14px;z-index:6;display:none;width:40px;height:40px;align-items:center;justify-content:center;border-radius:50%;border:1px solid var(--line);background:rgba(20,16,10,.66);color:var(--gold-soft);cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;transition:border-color .2s,color .2s,background .2s,transform .1s}'+
    '.region-close.show{display:flex}'+
    '.region-close:hover{border-color:rgba(201,162,74,.55);color:var(--gold);background:rgba(201,162,74,.12)}'+
    '.region-close:active{transform:scale(.9)}'+
    '.region-close svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;pointer-events:none}'+
    /* mobile: taller globe stage + a hint that it pinch-zooms */
    '@media (max-width:560px){.disc__globe{min-height:400px!important}}';
    document.head.appendChild(s); })();
  // Earth texture from Shopify's image CDN, resized + auto-WebP. Power-of-two widths so the
  // equirectangular texture wraps cleanly even on WebGL1. 2048 sharpens the globe on capable
  // machines (~300KB webp); 1024 keeps low-end/mobile light (~90KB).
  var TEX_W = (DEVMEM <= 2) ? 1024 : 2048; // 2048 webp is ~150KB — sharp on mobile too; only ultra-low-mem drops to 1024
  var EARTH = 'https://cdn.shopify.com/s/files/1/0550/8602/2678/files/earth-blue-marble.jpg?v=1785352713&width=' + TEX_W;

  var world=null, hintGone=false, idleTimer=null, activeId=null;

  function ang(a,b,c,d){ var R=Math.PI/180, dLa=(c-a)*R, dLo=(d-b)*R, la1=a*R, la2=c*R;
    var x=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(la1)*Math.cos(la2)*Math.sin(dLo/2)*Math.sin(dLo/2);
    return 2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x)); }
  function nearest(lat,lng){ var best=REGIONS[0], bd=1e9; REGIONS.forEach(function(r){ var d=ang(lat,lng,r.lat,r.lng); if(d<bd){ bd=d; best=r; } }); return best; }

  // Feature 1 — arc styling. Routes touching the selected region light up gold + brighter + faster.
  function arcHot(d){ return activeId && (d.from===activeId || d.to===activeId); }
  function arcColorFn(d){
    return arcHot(d)
      ? ['rgba(255,242,207,0.95)','rgba(255,217,118,0.85)','rgba(255,242,207,0.10)']
      : ['rgba(201,162,74,0.50)','rgba(227,201,135,0.60)','rgba(201,162,74,0.04)'];
  }
  function arcStrokeFn(d){ return arcHot(d) ? (IS_MOBILE?0.75:0.95) : (IS_MOBILE?0.32:0.42); }
  function arcTimeFn(d){ return arcHot(d) ? 1200 : 2600; }
  function arcAltFn(d){ var g=ang(d.startLat,d.startLng,d.endLat,d.endLng); return Math.min(0.55, 0.12 + g*0.16); }
  function refreshArcs(){ if(!world || !ARCS.length) return; try{ world.arcColor(arcColorFn).arcStroke(arcStrokeFn).arcDashAnimateTime(arcTimeFn); }catch(e){} }

  function openRegion(id, fromGlobe){
    activeId=id;
    var panels=document.querySelectorAll('.region-panel');
    for(var i=0;i<panels.length;i++){ panels[i].classList.toggle('active', panels[i].getAttribute('data-region')===id); }
    var chips=document.querySelectorAll('.region-chip');
    for(var j=0;j<chips.length;j++){ chips[j].classList.toggle('active', chips[j].getAttribute('data-region')===id); }
    var empty=document.getElementById('regionEmpty'); if(empty) empty.classList.add('hidden');
    var cb=document.getElementById('regionClose'); if(cb) cb.classList.add('show');
    if(world){
      var r=REGIONS.filter(function(x){return x.id===id;})[0];
      if(r){ world.controls().autoRotate=false; clearTimeout(idleTimer); world.pointOfView({lat:r.lat,lng:r.lng,altitude:1.85},1100); }
      try{ world.pointColor(function(d){ return d.id===activeId?'#ffffff':'#ffd976'; })
                .labelColor(function(d){ return d.id===activeId?'#ffffff':'#fff2cf'; }); }catch(e){}
      refreshArcs();
    }
    if(!fromGlobe && window.innerWidth<900){
      var wrap=document.getElementById('regionPanels'); if(wrap) wrap.scrollIntoView({behavior:'smooth',block:'center'});
    }
    hideHint();
  }
  function hideHint(){ if(hintGone) return; var h=document.getElementById('globeHint'); if(h){h.classList.add('gone');} hintGone=true; }

  // Close the open region: back to the empty state, deselect chips, resume the globe.
  function closeRegion(){
    activeId=null;
    var panels=document.querySelectorAll('.region-panel'); for(var i=0;i<panels.length;i++){ panels[i].classList.remove('active'); }
    var chips=document.querySelectorAll('.region-chip'); for(var j=0;j<chips.length;j++){ chips[j].classList.remove('active'); }
    var empty=document.getElementById('regionEmpty'); if(empty) empty.classList.remove('hidden');
    var cb=document.getElementById('regionClose'); if(cb) cb.classList.remove('show');
    if(world){
      try{ world.controls().autoRotate=true; }catch(e){}
      try{ world.pointColor(function(){ return '#ffd976'; }).labelColor(function(){ return '#fff2cf'; }); }catch(e){}
      refreshArcs();
    }
  }
  window.__ameenOpenRegion=openRegion;
  window.__ameenCloseRegion=closeRegion;

  // Inject a reliable, touch-friendly close (X) button into the panel container.
  (function(){
    var wrap=document.getElementById('regionPanels');
    if(wrap && !document.getElementById('regionClose')){
      var b=document.createElement('button');
      b.id='regionClose'; b.className='region-close'; b.type='button'; b.setAttribute('aria-label','Close region');
      b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg>';
      b.addEventListener('click', function(e){ e.preventDefault(); closeRegion(); });
      wrap.appendChild(b);
    }
  })();

  // Chips open their region — or, if already active, toggle it closed (an intuitive close on touch).
  document.querySelectorAll('.region-chip').forEach(function(c){
    c.addEventListener('click',function(){
      if(c.classList.contains('active')){ closeRegion(); }
      else { openRegion(c.getAttribute('data-region'), false); }
    });
  });

  // Feature 3 — 3D tilt toward the cursor on the region product cards.
  function bindTilt(){
    if(REDUCED || NO_HOVER) return;
    var cards=document.querySelectorAll('.rcard');
    for(var i=0;i<cards.length;i++){ (function(card){
      card.addEventListener('mousemove',function(e){
        var r=card.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
        card.classList.add('tilting');
        card.style.transform='perspective(620px) rotateY('+(px*11).toFixed(2)+'deg) rotateX('+(-py*11).toFixed(2)+'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave',function(){
        card.classList.remove('tilting');
        card.style.transform='';
      });
    })(cards[i]); }
  }

  // Feature 2 — atmosphere "bloom": briefly swell the glow on entrance, then settle.
  function bloomAtmosphere(){
    if(REDUCED || !world){ return; }
    var start=0.34, end=0.15, dur=1700, t0=null;
    try{ world.atmosphereAltitude(start); }catch(e){}
    function step(ts){ if(t0==null) t0=ts; var k=Math.min(1,(ts-t0)/dur); var e=1-Math.pow(1-k,3);
      try{ world.atmosphereAltitude(start+(end-start)*e); }catch(err){}
      if(k<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initGlobe(){
    var el=document.getElementById('globeViz');
    if(!el || typeof Globe==='undefined'){ return; }
    var host=el.closest('.disc__globe');
    world=Globe({rendererConfig:{antialias:!LOW, powerPreference:(LOW?'default':'high-performance'), alpha:true}})(el)
      .backgroundColor('rgba(0,0,0,0)')
      .globeImageUrl(EARTH)
      .showAtmosphere(true).atmosphereColor('#c9a24b').atmosphereAltitude((REDUCED||LOW)?0.15:0.34)
      .showGraticules(!LOW)
      .pointsData(REGIONS).pointLat('lat').pointLng('lng').pointAltitude(0.012).pointRadius(0.5).pointResolution(LOW?10:16).pointColor(function(){ return '#ffd976'; })
      .labelsData(REGIONS).labelLat('lat').labelLng('lng').labelText('name').labelSize(IS_MOBILE?1.95:1.35).labelDotRadius(IS_MOBILE?0.7:0.55).labelResolution(2).labelAltitude(0.014).labelColor(function(){ return '#fff2cf'; });
    try{ world.renderer().setPixelRatio(PXR); }catch(e){}
    // Rings continuously spawn/expire objects every frame — capable machines only.
    if(!LOW){
      try{
        world.ringsData(REGIONS).ringLat('lat').ringLng('lng')
          .ringColor(function(){ return function(t){ return 'rgba(201,162,74,'+(1-t)+')'; }; })
          .ringMaxRadius(3.2).ringPropagationSpeed(1.2).ringRepeatPeriod(2000);
      }catch(e){}
    }

    // Feature 1 — draw the animated spice-route arcs (fewer curve segments on low-end).
    if(!REDUCED && ARCS.length){
      try{
        world.arcsData(ARCS)
          .arcStartLat('startLat').arcStartLng('startLng').arcEndLat('endLat').arcEndLng('endLng')
          .arcColor(arcColorFn).arcStroke(arcStrokeFn).arcAltitude(arcAltFn).arcCurveResolution(LOW?32:64)
          .arcDashLength(0.45).arcDashGap(0.9).arcDashInitialGap(function(){ return Math.random()*2; })
          .arcDashAnimateTime(arcTimeFn).arcsTransitionDuration(0);
      }catch(e){}
    }

    var c=world.controls(); c.autoRotate=true; c.autoRotateSpeed=0.42; c.enablePan=false;
    // Pinch-to-zoom the globe on touch devices; kept OFF on desktop so the mouse wheel scrolls the page (no hijack).
    c.enableZoom=NO_HOVER; c.minDistance=150; c.maxDistance=480; c.zoomSpeed=0.85;
    c.rotateSpeed=0.55; c.enableDamping=true; c.dampingFactor=0.12;

    // Feature 2 — cinematic entrance: start pulled back, fade + fly in, bloom the atmosphere.
    // Low-end skips the JS camera fly + rAF bloom (keeps only the cheap CSS fade) to avoid first-load stutter.
    if(REDUCED || LOW){
      world.pointOfView({lat:18,lng:58,altitude:POV_ALT});
      if(host) host.classList.add('globe-ready');
    } else {
      world.pointOfView({lat:18,lng:58,altitude:3.7});
      requestAnimationFrame(function(){
        if(host) host.classList.add('globe-ready');
        world.pointOfView({lat:18,lng:58,altitude:2.4},2600);
        bloomAtmosphere();
      });
    }

    function idle(){ c.autoRotate=false; clearTimeout(idleTimer); idleTimer=setTimeout(function(){ if(!activeId) c.autoRotate=true; }, 5000); }
    el.addEventListener('mouseenter',function(){ c.autoRotate=false; });
    el.addEventListener('mouseleave',function(){ if(!activeId) c.autoRotate=true; });

    var downX=null, downY=null;
    function onDown(x,y){ downX=x; downY=y; idle(); hideHint(); }
    el.addEventListener('mousedown',function(e){ onDown(e.clientX,e.clientY); });
    el.addEventListener('touchstart',function(e){ if(e.touches&&e.touches[0]) onDown(e.touches[0].clientX,e.touches[0].clientY); },{passive:true});
    el.addEventListener('click',function(e){
      if(!world) return;
      if(downX!=null && (Math.abs(e.clientX-downX)>8 || Math.abs(e.clientY-downY)>8)){ downX=null; return; }
      downX=null;
      var rect=el.getBoundingClientRect();
      var g=null; try{ g=world.toGlobeCoords(e.clientX-rect.left, e.clientY-rect.top); }catch(err){}
      if(g) openRegion(nearest(g.lat, g.lng).id, true);
    });

    function resize(){ var r=el.getBoundingClientRect(); if(r.width) world.width(r.width).height(r.height); }
    resize(); window.addEventListener('resize',resize);

    // Perf: stop the WebGL render loop whenever the globe is scrolled offscreen or the tab is hidden,
    // so it costs zero frames while the visitor browses the rest of the page.
    var onScreen=true;
    function pause(){ if(onScreen){ onScreen=false; try{ world.pauseAnimation(); }catch(e){} } }
    function resume(){ if(!onScreen){ onScreen=true; try{ world.resumeAnimation(); }catch(e){} } }
    try{
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ if(es[0]){ es[0].isIntersecting ? resume() : pause(); } }, {threshold:0}).observe(el);
      }
    }catch(e){}
    document.addEventListener('visibilitychange', function(){
      if(document.hidden){ pause(); }
      else { var r=el.getBoundingClientRect(); if(r.bottom>0 && r.top<(window.innerHeight||0)) resume(); }
    });
  }

  bindTilt();

  var tries=0;
  function wait(){
    if(typeof Globe!=='undefined'){ initGlobe(); return; }
    if(tries++>60) return;
    setTimeout(wait,150);
  }
  var gv=document.getElementById('globeViz');
  if('IntersectionObserver' in window && gv){
    var io=new IntersectionObserver(function(es){ for(var i=0;i<es.length;i++){ if(es[i].isIntersecting){ io.disconnect(); wait(); return; } } }, {rootMargin:'300px'});
    io.observe(gv);
  } else { wait(); }
})();
